import React from 'react';

const RefundPolicy = () => {
  return (
    <div className="container mx-auto px-4 py-16 max-w-4xl text-left">
      <h1 className="text-3xl font-bold mb-8 text-left">Refund Policy</h1>

      <div className="prose prose-lg max-w-none text-left">
        <p>Effective Date: March 25th, 2025</p>

        <p className="mt-4">
          We stand behind the quality of our digital products. If for any reason you are not completely satisfied with your purchase, we offer a 30-day 100% money-back guarantee.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">1. Eligibility for Refund</h2>
        <p>
          To be eligible for a refund, you must request the refund within 30 days from the date of your purchase. After 30 days, we are unable to process any refund requests.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">2. How to Request a Refund</h2>
        <p>
          To request a refund, please contact us at: <a href="mailto:support@applaunchai.com">support@applaunchai.com</a> with the following information:
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li>Your order number</li>
          <li>The email address used to make the purchase</li>
          <li>A brief explanation of why you are requesting a refund</li>
        </ul>
        <p>
          Once we receive your refund request, we will review the information and process the refund within 7 business days.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">3. Refund Method</h2>
        <p>
          Refunds will be issued to the original payment method used at the time of purchase. If your payment was made via credit card, the refund may take several business days to reflect on your account depending on your bank's processing times.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">4. Limitations</h2>
        <p>
          The 30-day money-back guarantee applies only to purchases made directly from our website and is not applicable to any third-party resellers or distributors.
        </p>
        <p>
          Refunds will only be issued for the product you purchased. Additional services, such as consultation or customization, may be subject to a different refund policy.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">5. No Refunds After 30 Days</h2>
        <p>
          Refunds are not available after the 30-day window has passed. We recommend reviewing the product within the first 30 days to ensure that it meets your expectations.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">6. Contact Us</h2>
        <p>
          If you have any questions about our refund policy or need assistance with your purchase, please contact us at:
        </p>
        <p>
          <strong>Email:</strong> <a href="mailto:support@applaunchai.com">support@applaunchai.com</a>
        </p>
      </div>
    </div>
  );
};

export default RefundPolicy;
